import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { BellaTestIds } from 'Common/qaIds';
import { setSelectedQuantity } from 'Client/redux/productdetail/actions';
import { RecommendedProduct } from 'Client/redux/productdetail/types';
import { buildQuantityOptions } from 'Client/components/ProductDetailPage/QuantitySelector';
import StateInterface from 'Client/redux/types';
import { CartProductItem } from 'Client/redux/cart/types';
import Selector, { Options } from '@westwing/ui-kit/Selector';

const StyledSelector = styled(Selector)`
    flex-basis: 66px;
    flex-shrink: 0;
    margin-left: 12px;
`;

interface Props {
    availableQuantity: number;
    className?: string;
    simpleSku: string;
}

const selectorTestIds = {
    selectorDropdown: BellaTestIds.pdpSelectorDropdown,
    selectorOption: BellaTestIds.pdpSelectorOption,
    selectorLabel: BellaTestIds.pdpSelectorLabel,
    arrowElement: BellaTestIds.pdpSizeSelectorArrow,
    selectorContainer: BellaTestIds.pdpQuantitySelector,
    labelNote: BellaTestIds.note,
};

const AddOnProductQuantitySelector: React.FC<Props> = ({ availableQuantity, simpleSku, className }) => {
    const dispatch = useDispatch();
    const addOnProducts = useSelector<StateInterface, RecommendedProduct[]>(
        state => state.productdetails?.addOnProducts.products
    );

    const selectedQuantity =
        addOnProducts.find(product => product.simpleSku === simpleSku)?.userActions?.selectedQuantity || 1;

    const carts = useSelector<StateInterface, CartProductItem[]>(state => state.header.cart?.carts);
    const activeSimpleFromCart = useMemo(() => carts.find(x => x.sku === simpleSku), [carts, simpleSku]);

    const quantityOptions: Options[] = buildQuantityOptions(availableQuantity, selectedQuantity, activeSimpleFromCart);

    const changeQuantity = (quantity: string) => dispatch(setSelectedQuantity(Number(quantity), simpleSku, true));

    return (
        <StyledSelector
            options={quantityOptions}
            selectedLabel={quantityOptions.length >= selectedQuantity ? String(selectedQuantity) : '1'}
            selectedValue={quantityOptions.length >= selectedQuantity ? String(selectedQuantity) : '1'}
            onChange={changeQuantity}
            testIds={selectorTestIds}
            className={className}
        />
    );
};

export default AddOnProductQuantitySelector;
